<template>
  <div ref="ArabicTemp" class="d-none">
    <div v-html="EjsData"></div>
  </div>
</template>

<script>
import Printd from "printd";
import PosService from "@/services/PosService";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    ticketDetails: {
      type: Array
    }
  },
  data() {
    return {
      EjsData: null
    };
  },
  computed: {
    ...mapGetters(["IDforBoxOfficeEjs"]),
    isReprint() {
      return this.$store.getters.isReprint;
    }
  },
  mounted() {
    EventBus.$on("printArabicTemp", data => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printArabicTemp");
  },
  methods: {
    GetEjsTicket: function() {
      let loader = this.$loading.show();

      PosService.GetTicketEjs(
        this.IDforBoxOfficeEjs.sb_id,
        this.IDforBoxOfficeEjs.cinema_id,
        this.isReprint
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.ArabicTemp) {
        p.print(this.$refs.ArabicTemp, []);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/PrintTicketTemplates/Arabic_Template.vue